import type { InternalRequest } from '../client.js';

export type ReportParams = Record<string, string | number | boolean | undefined | null>;

function qs(params: ReportParams): string {
  const usp = new URLSearchParams();
  for (const [k, v] of Object.entries(params)) {
    if (v != null && v !== '') usp.set(k, String(v));
  }
  return usp.toString();
}

/**
 * Report endpoints return distance in METERS and duration / engineMs in
 * MILLISECONDS. Do not add a second human-friendly unit layer — convert in
 * the UI formatter only. (See CLAUDE.md "Reports API unit boundary".)
 * There is NO /api/reports/route — route replay goes through /positions/:id.
 */
export function reportsEndpoints(req: InternalRequest) {
  return {
    trips: (params: ReportParams) =>
      req.request<unknown[]>(`/reports/trips?${qs(params)}`),
    stops: (params: ReportParams) =>
      req.request<unknown[]>(`/reports/stops?${qs(params)}`),
    // Server-side aggregation is uncapped (issue #328) — routinely exceeds
    // the 15s default deadline on larger orgs/date ranges.
    summary: (params: ReportParams) =>
      req.request<unknown[]>(`/reports/summary?${qs(params)}`, { timeoutMs: 60_000 }),
  };
}
